"use client";

import { manrope, ubuntu } from "../../ui/fonts";
import { Carousel } from "@material-tailwind/react";
import Link from "next/link";
import { CarrouselMovileShowroom } from "../home/CarrouselMovileShowroom";
import ArrowRight from "../svg/ArrowRight";
import ArrowsLeft from "../svg/ArrowsLeft";

export const ShowRoomComponent = () => {
  return (
    <>
      <div className="w-full bg-black relative z-10 lg:h-[665px] lg:px-0">
        {/* PC */}
        <Carousel
          autoplay={true}
          loop={true}
          autoplayDelay={3000}
          prevArrow={({ loop, handlePrev, firstIndex }) => {
            return (
              <button
                onClick={handlePrev}
                disabled={!loop && firstIndex}
                className="!absolute top-2/4 left-4 -translate-y-2/4 rounded-[50%] border border-black bg-white select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[42px] h-12 max-h-[42px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
              >
                <ArrowsLeft />
              </button>
            );
          }}
          nextArrow={({ loop, handleNext, lastIndex }) => (
            <button
              onClick={handleNext}
              disabled={!loop && lastIndex}
              className="!absolute top-2/4 right-4 -translate-y-2/4 rounded-full select-none transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none w-12 max-w-[48px] h-12 max-h-[48px] text-white hover:bg-white/10 active:bg-white/30 grid place-items-center"
            >
              <ArrowRight />
            </button>
          )}
          className="carrusel-showRoom-home relative hidden overflow-x-hidden bg-black lg:flex"
        >
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="https://test.mincaelectric.com/wp-content/uploads/2025/05/Minca-electric-cc-mall-plaza-bogota.webp"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        CC Mallplaza
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Avenida Calle 19 No. 28-80
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Bogotá
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados de 11.00am a 7.00pm.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  {/* <Link
                    href="/testdrive/showroomavenidachile"whats
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link> */}
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://g.co/kgs/QDtMpv2"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showrrom  CC Santafe */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="https://test.mincaelectric.com/wp-content/uploads/2024/11/Showroom-cc-Santafe-Minca-Electric.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-x-6 gap-y-12">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        CC Santafé
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Plaza Italia - Zona MET primer piso
                        </p>
                        {/* <p className={`${ubuntu.className} text-base`}>
                          Medellín, Colopbia
                        </p> */}
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados de 11.00am a 7.00pm.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                        <p className="invisible">Cerrado los Feriados.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomCcSantafe"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/rMLQ1VJtrjRn7j2E6"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showrrom  Medellin */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="https://test.mincaelectric.com/wp-content/uploads/2024/10/SHOWROOM-MEDELLIN.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-x-6 gap-y-12">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Medellín:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        Av. Las Vegas
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Carrera 48 # 1 Sur - 110,
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Medellín, Colopbia
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 10:00 a.m. - 07:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados: 10:00 a.m. - 06:00 p.m.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 10:00 a.m. - 05:00 p.m.
                          </p>
                        }
                        <p>Cerrado los Feriados.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomlasvegas"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/gV443hZfGwdQa54h8"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showroom Chico */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="/sedes/Showroom Chicó - Minca electric.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div>
                <div className="flex gap-4">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div>
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div>
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div>
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        chicó
                      </h1>
                    </div>
                    <div>
                      <div>
                        <p className={`${ubuntu.className} text-base`}>
                          Cra. 11a #94a-56
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados: 09:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Domingos: 11:00 a.m. - 06:00 p.m.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomchico"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/2wDShqWLvxBDL4fB9"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/*  Showrrom Javeriana */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="https://test.mincaelectric.com/wp-content/uploads/2024/10/Showroom-Javeriana-Minca-Electric-1.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        alt="pointer map"
                        loading="lazy"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        Javeriana
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Carrera 7 # 45-10
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados: 11:00 a.m. - 07:00 p.m.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomjaveriana"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/9gKCxcucQG86NJFt6"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showrrom  Cedritos */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="/sedes/Showroom Cedritos - Minca electric.png"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        Cedritos
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Av. Cra. 19#143A-08
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados: 09:00 a.m. - 08:00 p.m.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomcedritos"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/Jxb663iCvnFNSLg89"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showrrom  Gran Estación */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="/sedes/Showroom Gran Estación - Minca electric.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        Gran Estación
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Centro Comercial Gran Estacion
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Isla, 2-02, Bogotá
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados de 11.00am a 7.00pm.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomgranestacion"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/MWC7qMyC6tiivvEe7"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Showrrom  Avenida Chile */}
          <section className="flex h-full w-full">
            <div className="ladoIzquierdo grid h-full w-full place-items-center">
              {/* La imagen es un backGround */}
              <img
                className="h-[665px] w-full object-cover object-top"
                src="/sedes/Showroom Avenida Chile - Minca electric.jpg"
                loading="lazy"
                alt="icono de herramientas"
              />
            </div>
            <div className="ladoDerecho hidden h-full w-full place-items-center bg-black text-white lg:grid ">
              <div className="">
                <div className="flex gap-4 ">
                  <div className="columna-img pb-[15px] flex h-auto w-[60px] flex-col justify-end gap-6">
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/map.png"
                        loading="lazy"
                        alt="pointer map"
                      />
                    </div>
                    <div className="">
                      <img
                        className="h-[50px] w-[50px]"
                        src="/calendario.png"
                        loading="lazy"
                        alt="icono calendario"
                      />
                    </div>
                  </div>
                  <div>
                    <div className="">
                      <p className={`${ubuntu.className} text-left text-base`}>
                        Visita nuestras sedes Minca:
                      </p>
                      <h2 className="mt-[50px] uppercase">Bogotá:</h2>
                      <h1
                        className={`${manrope.className} pb-[27px] leading-[35px] text-left text-[32px] font-bold uppercase`}
                      >
                        showroom <br />
                        Avenida Chile
                      </h1>
                    </div>
                    <div>
                      <div className="">
                        <p className={`${ubuntu.className} text-base`}>
                          Calle 72 # 25-10,
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Bogotá
                        </p>
                      </div>
                      <div className="mt-6">
                        <p className={`${ubuntu.className} text-base`}>
                          Lunes a viernes: 11:00 a.m. - 08:00 p.m.
                        </p>
                        <p className={`${ubuntu.className} text-base`}>
                          Sábados: 09:00 a.m. - 08:00 p.m.
                        </p>
                        {
                          <p className={`${ubuntu.className} text-base`}>
                            Domingos: 11:00 a.m. - 06:00 p.m.
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ml-[60px] mt-6 flex flex-col items-center justify-center">
                  <Link
                    href="/testdrive/showroomavenidachile"
                    className={`${ubuntu.className} border-1 my-3 grid h-[52px] w-full  place-items-center rounded-[62px] border border-white bg-black text-[16px] text-white  lg:w-[290px]`}
                  >
                    Agendar Test Drive
                  </Link>
                  <div className="item flex w-full justify-center text-center text-[14px] underline">
                    <Link
                      target="_blank"
                      href="https://maps.app.goo.gl/gyNEg69D1ArdESR2A"
                    >
                      Ver ubicación en Google Maps
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Carousel>
      </div>
      {/* Mobile */}
      <div className="lg:hidden">
        <CarrouselMovileShowroom />
      </div>
    </>
  );
};
